// SPDX-License-Identifier: AGPL-3.0-or-later

import UnicodeEmojis from '@app/features/expressions/utils/UnicodeEmojis';
import type {ReactionEmoji} from '@app/features/messaging/utils/ReactionUtils';

export function unicodeBatShortNameMatches(name: string): boolean {
	return name.toLowerCase() === 'bat';
}

export function isUnicodeBatReaction(emoji: ReactionEmoji): boolean {
	if (emoji.id != null) return false;
	const surrogate = UnicodeEmojis.normalizeEmojiNameToSurrogate(emoji.name);
	const shortName = UnicodeEmojis.getSurrogateName(surrogate) ?? emoji.name;
	return unicodeBatShortNameMatches(shortName);
}
